// アプリケーションバージョン
// ルール: Claude による修正を含む全ての変更でマイナーバージョンを必ずインクリメントする
// フォーマット: MAJOR.MINOR (例: 1.20)
// - MAJOR: 大規模な設計変更・破壊的変更時のみ上げる
// - MINOR: バグ修正・機能追加・UI変更など全ての修正で +1 する
export const APP_VERSION = "1.68";
